import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button,
    MenuItem,
    InputLabel,
    FormControl,
  } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import { TextField, Select } from "formik-material-ui";
import * as Yup from "yup";


const infoSchema = Yup.object().shape({
    skill: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    proficiency: Yup.string().required("Required"),
    experience: Yup.string().required("Required"),
});

const SkillModal = (props) => {
    const { user } = useAuth0()

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        console.log(values)
        if(props.skill.id === ''){
            fetch(process.env.REACT_APP_IP + `/talents/${ user.sub }/skills`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values)
            }).then(res => res.json())
            .then(res => console.log(res));
        } else {
            fetch(process.env.REACT_APP_IP + `/talents/${ user.sub }/skills/${ props.skill.id }`, {
                method: 'PATCH',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values)
            }).then(res => res.json())
            .then(res => console.log(res));
        }
        props.refresh();
        props.onClose();
    }

    return (
            <Dialog open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Skill</DialogTitle>
                <Formik
                initialValues={{
                    skill: props.skill.skill,
                    proficiency: props.skill.proficiency,
                    experience: props.skill.experience,
                }}
                validationSchema={infoSchema}
                onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
                }}
                >
                {({ submitForm, isSubmitting }) => (
                    <Form>
                        <DialogContent>
                        <Field
                        required
                        fullWidth
                        name="skill"
                        component={TextField}
                        id="skill-required"
                        label="Skill"
                        />
                        <FormControl fullWidth>
                            <InputLabel htmlFor="proficiency">Proficiency</InputLabel>
                            <Field
                            required
                            component={Select}
                            name="proficiency"
                            inputProps={{
                                id: "proficiency",
                            }}>
                                <MenuItem value={"Beginner"}>Beginner</MenuItem>
                                <MenuItem value={"Intermediate"}>Intermediate</MenuItem>
                                <MenuItem value={"Advanced"}>Advanced</MenuItem>
                            </Field>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="experience">Experience</InputLabel>
                            <Field
                            required
                            component={Select}
                            name="experience"
                            inputProps={{
                                id: "experience",
                            }}>
                                <MenuItem value={"1 - 3"}>1 - 3</MenuItem>
                                <MenuItem value={"3 - 5"}>3 - 5</MenuItem>
                                <MenuItem value={"more than 5"}>more than 5</MenuItem>
                            </Field>
                        </FormControl>
                        </DialogContent>
                        <DialogActions>
                        <Button disabled={isSubmitting} color="primary" onClick={submitForm}>
                            Update
                        </Button>
                        <Button disabled={isSubmitting} color="primary" onClick={props.onClose}>
                            cancel
                        </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
 
export default SkillModal;